<template>
  <div id="app" class="docutax-app">
    <el-container class="full-height">
      <el-header class="header" height="96px">
        <a href="https://www.mmtax.com"
          ><img class="logo" src="./assets/MM_Tax_Service_logo.png"
        /></a>
      </el-header>
      <router-view></router-view>
      <el-footer height="80px">
        <div>
          <h4>For questions or support, call <a href="tel:+18888461056">(888) 846-1056</a></h4>
          <p style="font-size: 11px">
            &copy;Copyright {{ new Date().getFullYear() }} M &amp; M Income Tax Service. All rights
            reserved. <a href="https://mmtax.com/privacypolicy/">Privacy Policy</a>
          </p>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css';

export default {
  name: 'app',
  data() {
    return {};
  },
  methods: {},
  computed: {},
  components: {},
};
</script>

<style lang="scss">
body {
  margin: 0;
  font-size: 14px;
  line-height: 1.61;
  font-family: 'Open Sans', Helvetica, sans-serif;
}

p {
  margin-block-start: 0;
  margin-block-end: 0;
}

[class^='el-icon-my'],
[class*=' el-icon-my'] {
  font-family: 'FontAwesome' !important;
  /* The following is based on original CSS rules of third-party library */
  font-size: inherit;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fa {
  font-size: 1.2em;
  padding: 0 5px;
}

.docutax-app {
  height: 100vh;
  width: 100%;
  align-items: stretch;

  a {
    color: #2d2f33;
  }

  .el-table .cell,
  .el-dialog__body {
    word-break: break-word;
  }

  .full-height {
    height: 100vh;
  }

  .header {
    height: 60px;
    width: 100%;
    padding: 0 18px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 8px 3px rgba(100, 100, 100, 0.1), 0 2px 8px 0px rgba(100, 100, 100, 0.1);
    z-index: 10;
  }

  .el-footer {
    display: flex;
    flex-direction: column;
    border-top: 1px #ccc dashed;
    justify-content: space-around;
    text-align: center;

    h4,
    p {
      margin: 0;
    }
  }

  .el-container {
    min-width: 0;
  }

  .ma-0 {
    margin: 0;
  }

  .mt-0 {
    margin-top: 0;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .ma-3 {
    margin: 18px;
  }

  .mt-3 {
    margin-top: 18px;
  }

  .mb-3 {
    margin-bottom: 18px;
  }

  .mr-3 {
    margin-right: 18px;
  }

  .ml-3 {
    margin-left: 18px;
  }

  .ml-0 {
    margin-left: 0;
  }

  .pa-0 {
    padding: 0;
  }

  .pa-3 {
    padding: 18px;
  }

  .pb-3 {
    padding-bottom: 18px;
  }

  .align-center {
    text-align: center;
  }

  .align-right {
    text-align: right;
  }

  .text-uppercased {
    text-transform: uppercase;
  }

  .text-italic {
    font-style: italic;
  }

  .normal-word-wrap {
    word-wrap: normal;
    word-break: normal;
  }

  .el-dialog {
    min-width: 360px;
  }

  .strike {
    text-decoration: line-through;
  }
}

.el-menu--vertical .el-menu--popup,
.el-menu--vertical .el-menu--popup li > div {
  padding: 0;
  margin: 0;
}
</style>
